import { apiGetList, apiPost, apiPut, apiDelete } from "services/api";

export const getDiscounts = () =>
  apiGetList("discounts", { page: 1, pageSize: 1000 });

export const createDiscount = (payload) => apiPost("discounts/create", payload);

export const updateDiscount = (payload) => apiPut("discounts/update", payload);

export const deleteDiscount = (discountid) =>
  apiDelete("discounts", { discountid: Number(discountid) });
